import { render, staticRenderFns } from "./CourseOutcomes.vue?vue&type=template&id=1f2c58b1"
import script from "./CourseOutcomes.vue?vue&type=script&lang=js"
export * from "./CourseOutcomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports